import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";

var _templateObject,
    _effectorFileName = "/builds/gmini/ui-common/src/Dialog/Dialog.styled.tsx",
    _templateObject2,
    _templateObject3;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
export var DialogWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n  ", "\nheight:100%;\n  outline: 0;\n"])), function (props) {
  return props.scroll === 'body' ? 'overflow-x:hidden; overflow-y:auto; text-align:center;' : 'display:flex; align-items:center; justify-content:center;';
}, function (props) {
  return props.scroll === 'body' ? "&::after{\n    width: 0;\n    height: 100%;\n    content: \"\";\n    display: inline-block;\n    vertical-align: middle;\n}" : '';
});
export var PaperWrapper = styled(function (_ref) {
  var className = _ref.className,
      PaperComponent = _ref.PaperComponent,
      children = _ref.children;
  return /*#__PURE__*/_jsx(PaperComponent, {
    role: "dialog",
    className: className,
    elevation: 24,
    children: children
  });
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin: 32px;\n  position: relative;\n  overflow-y: auto;\n  ", ";\n  max-width: ", ";\n  ", "\n"])), function (props) {
  return props.scroll === 'body' ? 'display: inline-block;text-align: left;vertical-align: middle;' : 'display: flex;max-height: calc(100% - 64px);flex-direction: column;';
}, function (props) {
  switch (props.maxWidth) {
    case 'xs':
      return '444px';

    case 'sm':
      return '600px';

    case 'md':
      return '960px';

    case 'lg':
      return '1280px';

    case 'xl':
      return '1920px';

    case false:
      return 'none';
  }
}, function (props) {
  return props.fullWidth ? 'width:calc(100% - 64px);' : '';
});
export var DialogRoot = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: fixed;\n  z-index: 1300;\n  inset: 0px;\n"])));